import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Home = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4c9__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4c9__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M22.75 4.438a2 2 0 0 1 2.5 0l15 12A2 2 0 0 1 41 18v24a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V18a2 2 0 0 1 .75-1.562l15-12ZM11 40h6V29a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v11h6V18.961l-13-10.4-13 10.4V40Zm16 0v-9h-6v9h6Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
